<template>
  <div class="w-100 p-2 mt-2">
    <page-header :name="'Dashboard'">
      <i class="fas fa-clipboard-list"></i> {{ $t('page.title.dashboard') }}
      <template v-slot:right>
        <b-button @click="killAll()" size="xl" variant="danger">{{ $t('btn.kill_active_games') }}</b-button>
      </template>
    </page-header>

    <section class="content">
      <div class="container-fluid" v-if="dashboard">
        <div class="row">
          <div class="col-lg-4 col-6">
            <div class="info-box flex-column bg-gradient-primary mb-3" v-if="dashboard.registeredPlayers">
              <h5 class="ml-3">{{$t('dashboard.box.title.registered_players')}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-person-plus-fill></b-icon-person-plus-fill>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.today')}}</span>
                    <span class="text-bold">{{ dashboard.registeredPlayers.today }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.yesterday')}}</span>
                    <span class="text-bold">{{ dashboard.registeredPlayers.yesterday }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.mtd')}}</span>
                    <span class="text-bold">{{ dashboard.registeredPlayers.currentMonth }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.total')}}</span>
                    <span class="text-bold">{{ dashboard.registeredPlayers.total }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-box flex-column bg-gradient-primary mb-3">
              <h5 class="ml-3">{{$t('dashboard.box.title.online')}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-toggle-on></b-icon-toggle-on>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.player_online')}}</span>
                    <span class="text-bold">{{ dashboard.playerOnlineCount }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.game_online_count')}}</span>
                    <span class="text-bold">{{ dashboard.gameOnlineCount }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.dem_game_online_count')}}</span>
                    <span class="text-bold">{{ dashboard.demoGameOnlineCount }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>&nbsp;</span>
                    <span class="text-bold">&nbsp;</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>&nbsp;</span>
                    <span class="text-bold">&nbsp;</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>&nbsp;</span>
                    <span class="text-bold">&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-box flex-column bg-gradient-info mb-3" v-if="dashboard.playedGames">
              <h5 class="ml-3">{{$t('dashboard.box.title.played_games')}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-shuffle></b-icon-shuffle>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.today')}}</span>
                    <span class="text-bold">{{ dashboard.playedGames.today }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.yesterday')}}</span>
                    <span class="text-bold">{{ dashboard.playedGames.yesterday }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.mtd')}}</span>
                    <span class="text-bold">{{ dashboard.playedGames.currentMonth }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.total')}}</span>
                    <span class="text-bold">{{ dashboard.playedGames.total }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-box flex-column bg-gradient-info mb-3" v-if="dashboard.playedGames">
              <h5 class="ml-3">{{$t('dashboard.box.title.played_demo_games')}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-shuffle></b-icon-shuffle>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.today')}}</span>
                    <span class="text-bold">{{ dashboard.playedDemoGames.today }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.yesterday')}}</span>
                    <span class="text-bold">{{ dashboard.playedDemoGames.yesterday }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.mtd')}}</span>
                    <span class="text-bold">{{ dashboard.playedDemoGames.currentMonth }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.total')}}</span>
                    <span class="text-bold">{{ dashboard.playedDemoGames.total }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-box flex-column bg-gradient-info mb-3" v-if="dashboard.uniquePlayers">
              <h5 class="ml-3">{{$t('dashboard.box.title.unique_players')}}</h5>
              <div class="d-flex">
              <span class="info-box-icon">
                <b-icon-person-badge></b-icon-person-badge>
              </span>
              <div class="info-box-content">
                <div class="d-flex flex-row justify-content-between">
                  <span class="text-bold">{{$t('dashboard.box.label.today')}}</span>
                  <span class="text-bold">{{ dashboard.uniquePlayers.today }}</span>
                </div>

                <div class="d-flex flex-row justify-content-between">
                  <span>{{$t('dashboard.box.label.yesterday')}}</span>
                  <span class="text-bold">{{ dashboard.uniquePlayers.yesterday }}</span>
                </div>

                <div class="d-flex flex-row justify-content-between">
                  <span>{{$t('dashboard.box.label.mtd')}}</span>
                  <span class="text-bold">{{ dashboard.uniquePlayers.currentMonth }}</span>
                </div>

                <div class="d-flex flex-row justify-content-between">
                  <span>{{$t('dashboard.box.label.total')}}</span>
                  <span class="text-bold">{{ dashboard.uniquePlayers.total }}</span>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-6">
            <div class="info-box flex-column bg-gradient-success mb-3" v-for="(depo, index) in dashboard.deposits" :key="depo.currency+index">
              <h5 class="ml-3">{{$t('dashboard.box.title.deposits')}} - {{depo.currency}} </h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-cash-stack></b-icon-cash-stack>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.today')}}</span>
                    <span class="text-bold">{{ depo.today | numberFormat }} {{depo.currency}}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.yesterday')}}</span>
                    <span class="text-bold">{{ depo.yesterday | numberFormat}} {{depo.currency}}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.mtd')}}</span>
                    <span class="text-bold">{{ depo.currentMonth | numberFormat}} {{depo.currency}}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.total')}}</span>
                    <span class="text-bold">{{ depo.total | numberFormat}} {{depo.currency}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-box flex-column bg-gradient-maroon mb-3" v-for="(depo, index) in dashboard.resale" :key="depo.currency+index+1010">
              <h5 class="ml-3"> {{$t('dashboard.box.title.withdrawals')}} - {{depo.currency}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                <b-icon-archive></b-icon-archive>
              </span>
              <div class="info-box-content">
                <div class="d-flex flex-row justify-content-between">
                  <span class="text-bold">{{$t('dashboard.box.label.today')}}</span>
                  <span class="text-bold">{{ depo.today | numberFormat }} {{depo.currency}}</span>
                </div>

                <div class="d-flex flex-row justify-content-between">
                  <span>{{$t('dashboard.box.label.yesterday')}}</span>
                  <span class="text-bold">{{ depo.yesterday | numberFormat}} {{depo.currency}}</span>
                </div>

                <div class="d-flex flex-row justify-content-between">
                  <span>{{$t('dashboard.box.label.mtd')}}</span>
                  <span class="text-bold">{{ depo.currentMonth | numberFormat}} {{depo.currency}}</span>
                </div>

                <div class="d-flex flex-row justify-content-between">
                  <span>{{$t('dashboard.box.label.total')}}</span>
                  <span class="text-bold">{{ depo.total | numberFormat}} {{depo.currency}}</span>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-6">
            <div class="info-box flex-column bg-gradient-navy mb-3" v-if="dashboard.firstTimeDepositPlayers">
              <h5 class="ml-3">{{$t('dashboard.box.title.first_time_deposits')}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                <b-icon-cash></b-icon-cash>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.today')}}</span>
                    <span class="text-bold">{{ dashboard.firstTimeDepositPlayers.today }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.yesterday')}}</span>
                    <span class="text-bold">{{ dashboard.firstTimeDepositPlayers.yesterday }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.mtd')}}</span>
                    <span class="text-bold">{{ dashboard.firstTimeDepositPlayers.currentMonth }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.total')}}</span>
                    <span class="text-bold">{{ dashboard.firstTimeDepositPlayers.total }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-box flex-column bg-gradient-navy mb-3" v-for="(depo, index) in dashboard.pendingResale" :key="depo.currency+index+1010">
              <h5 class="ml-3">{{$t('dashboard.box.title.pending_withdrawals')}} - {{depo.currency}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-archive></b-icon-archive>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row justify-content-between">
                    <span class="text-bold">{{$t('dashboard.box.label.todayPendingResaleCount')}}</span>
                    <span class="text-bold">{{ depo.todayPendingResaleCount }}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.todayPendingResaleTotalSum')}}</span>
                    <span class="text-bold">{{ depo.todayPendingResaleTotalSum | numberFormat}} {{depo.currency}}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.notTodayPendingResaleCount')}}</span>
                    <span class="text-bold">{{ depo.notTodayPendingResaleCount}}</span>
                  </div>

                  <div class="d-flex flex-row justify-content-between">
                    <span>{{$t('dashboard.box.label.notTodayPendingResaleTotalSum')}}</span>
                    <span class="text-bold">{{ depo.notTodayPendingResaleTotalSum | numberFormat}} {{depo.currency}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import axios from "axios";
import PageHeader from "../../components/page/PageHeader";
import alertify from "alertifyjs";

export default {
  components: {PageHeader},
  data() {
    return {
      activeGamesCount: 'loading...',
      activeGames: [],
      timeout: null
    };
  },
  mounted() {
    axios.defaults.headers.common['X-AUTH-TOKEN'] = this.apiKey;
    this.$store.dispatch('dashboardStore/getDashboard');
  },
  computed: {
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    },
    dashboard: function () {
      return this.$store.getters["dashboardStore/dashboard"];
    }
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
  methods: {
    killAll() {
      axios.delete('/api/game/kill/active-games')
          .then(function () {
            alertify.success('Kill games success.');
          })
          .catch(error => {
            console.log(error);
          });
    },
    refresh() {
      let _that = this;
      axios.get('/api/management/active-game')
          .then(function (response) {
            _that.activeGames = response.data.items;
            _that.activeGamesCount = response.data.items.length
            _that.timeout = setTimeout(() => {
              _that.refresh();
            }, 1000);
          })
          .catch(error => {
            console.log(error);
          });

    }
  },
  watch: {}
}
</script>
